import axios from "axios";
import React from "react";
import { singletonHook } from "react-singleton-hook";

export interface AttendeeMetadata {
    terms: boolean;
    privacy: boolean;
    marketing: boolean;
}

export interface Attendee {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    mobileNumber: string;
    school: string;
    hasSeenWelcomePage: boolean;
    favorites: string[];
    visited: string[];
    mySchedule: string[];
    metadata: string;
}
export const GetAttendeeMetadata = (attendee: Attendee): AttendeeMetadata => {
    return JSON.parse(attendee.metadata || "{}") as AttendeeMetadata;
};

export const CreateAttendee = async (): Promise<Attendee> => {
    let attendeeJSON = await localStorage.getItem("attendee");
    // console.log(attendeeJSON);
    if (attendeeJSON) {
        try {
            let attendee = JSON.parse(attendeeJSON) as Attendee;

            if (attendee && attendee.id) {
                let attendeeRes = await axios.get(`${Server}/api/attendees/${attendee.id}`);
                // console.log(attendeeRes);
                await localStorage.setItem("attendee", JSON.stringify(attendeeRes.data));
                attendeeRes.data.metadata = attendee.metadata;
                return attendeeRes.data;
            }
        } catch (e) {
            // console.log(e);
        }
    }

    let res = await axios.post(`${Server}/api/attendees`, {
        firstName: "",
        lastName: "",
        email: "",
        mobileNumber: "",
        school: "",
        hasSeenWelcomePage: false,
        favorites: [],
        visited: [],
        mySchedule: [],
    });

    // console.log(res);

    if (res.status === 200 && res.data) {
        await localStorage.setItem("attendee", JSON.stringify(res.data));
        return res.data as Attendee;
    }
    return {} as Attendee;
};

export const UpdateProfile = async (attendee: Attendee) => {
    return axios.post(`${Server}/api/attendees/updateProfile`, {
        userID: attendee.id,
        firstName: attendee.firstName,
        lastName: attendee.lastName,
        email: attendee.email,
        mobileNumber: attendee.mobileNumber,
        school: attendee.school,
        hasSeenWelcomePage: true,
        favorites: attendee.favorites,
        visited: attendee.visited,
        mySchedule: attendee.mySchedule,
    });
};

export const UpdateMetadata = async (attendee: Attendee, metadata: AttendeeMetadata) => {
    return axios.post(`${Server}/api/attendees/updateMetadata`, {
        userID: attendee.id,
        metadata: JSON.stringify(metadata),
    });
};

const init = { user: {} as Attendee, getUser: () => {} };

const userFactory = () => {
    const [user, setUser] = React.useState({} as Attendee);

    React.useEffect(() => {
        CreateAttendee().then((user) => {
            setUser(user);
        });
    }, []);

    const getUser = async () => {
        CreateAttendee().then((user) => {
            setUser(user);
        });
    };

    return { user, getUser };
};

export const useUser = singletonHook(init, userFactory);
